// extracted by mini-css-extract-plugin
module.exports = {"startDate":"EventTile_startDate__3Lein"};